'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('survey', {
    url: '/survey',
    template: '<survey></survey>'
  });
}



// WEBPACK FOOTER //
// ./client/app/survey/survey.routes.js